'use client';

import { useTranslations } from 'next-intl';
import useFilter from 'hooks/use-filter';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import styles from './clear-all-filter.module.scss';
import cx from 'classnames';
import { useLoaderOverlay } from 'app/[lang]/[esite]/contexts/loader-overlay-context';

export interface ClearAllFilterProps {
  facets: string[] | string;
  className?: string;
}

const ClearAllFilter = ({ facets, className }: ClearAllFilterProps) => {
  const t = useTranslations();
  const { handleClearAllFilters } = useFilter();
  const { setSelectedFacets, startTransition } = useLoaderOverlay();

  const handleClearFilter = () => {
    startTransition(() => {
      handleClearAllFilters(facets);
      setSelectedFacets(undefined);
    });
  };

  return (
    <CatButton
      className={cx(styles['button--clear-padding'], className)}
      variant="ghost"
      onClick={handleClearFilter}
    >
      {t('MULTI_SELECT_CLEAR_ALL_FILTERS')}
    </CatButton>
  );
};

export default ClearAllFilter;
